import { z } from 'zod'

const schema = z.object({
  VITE_APP_ENV: z.enum(['local', 'staging', 'production']).default('local'),
  VITE_DATA_SOURCE: z.enum(['fixtures', 'supabase']).default('fixtures'),
  VITE_SUPABASE_URL: z.url().optional(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1).optional(),
  VITE_GOOGLE_MAPS_API_KEY: z.string().min(1).optional(),
  /** ID de carte Google (Map Management, type vectoriel) : rotation native de la carte suivant le cap. */
  VITE_GOOGLE_MAPS_MAP_ID: z.string().trim().min(1).optional(),
  /** Jeton public Mapbox : trajet suggéré par les rues. Absent : option masquée. */
  VITE_MAPBOX_TOKEN: z.string().trim().min(1).optional(),
  /** Laboratoire de simulation `/labo` : réservé au mode fixtures, jamais avec les données réelles. */
  VITE_LAB_ENABLED: z.enum(['true', 'false']).default('false'),
  /** Outils de calibration TEMPORAIRES (diagnostic, fenêtre « Profil » à la place de « Pause ») : jamais en production. */
  VITE_CALIBRATION_TOOLS: z.enum(['true', 'false']).default('true'),
})

export type RuntimeConfig =
  | {
      dataSource: 'fixtures'
      appEnvironment: string
      googleMapsApiKey?: string
      googleMapsMapId?: string
      mapboxToken?: string
      labEnabled: boolean
      calibrationTools: boolean
    }
  | {
      dataSource: 'supabase'
      appEnvironment: string
      calibrationTools: boolean
      googleMapsApiKey?: string
      googleMapsMapId?: string
      mapboxToken?: string
      labEnabled: false
      supabaseUrl: string
      supabaseAnonKey: string
    }

export function parseEnvironment(input: Record<string, unknown>): RuntimeConfig {
  const env = schema.parse(input)
  const shared = {
    appEnvironment: env.VITE_APP_ENV,
    calibrationTools: env.VITE_APP_ENV !== 'production' && env.VITE_CALIBRATION_TOOLS === 'true',
    ...(env.VITE_GOOGLE_MAPS_API_KEY ? { googleMapsApiKey: env.VITE_GOOGLE_MAPS_API_KEY } : {}),
    ...(env.VITE_GOOGLE_MAPS_MAP_ID ? { googleMapsMapId: env.VITE_GOOGLE_MAPS_MAP_ID } : {}),
    ...(env.VITE_MAPBOX_TOKEN ? { mapboxToken: env.VITE_MAPBOX_TOKEN } : {}),
  }
  if (env.VITE_DATA_SOURCE === 'fixtures') {
    return { ...shared, dataSource: 'fixtures', labEnabled: env.VITE_LAB_ENABLED === 'true' }
  }
  if (!env.VITE_SUPABASE_URL || !env.VITE_SUPABASE_ANON_KEY) {
    throw new Error('Configuration Supabase incomplète : VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY.')
  }
  return {
    ...shared,
    dataSource: 'supabase',
    labEnabled: false,
    supabaseUrl: env.VITE_SUPABASE_URL,
    supabaseAnonKey: env.VITE_SUPABASE_ANON_KEY,
  }
}

export const runtimeConfig = parseEnvironment(import.meta.env)
